import { Request } from '../../../httpClient/serverApi/requests/Request';
import { ILicenseConsumptionInfo } from '../types/ILicenseConsumptionInfo';

export class GetSiteLicensingConsumptionInfoRequest extends Request<{}, ILicenseConsumptionInfo> {
  constructor() {
    super('getSiteLicensingConsumptionInfo', {});
  }
}
